import { Typography } from '@design-system';
import { TestsheetListingItem } from '@services';
import './TestsheetCard.scss';
import { TestsheetStatusProvider } from './TestsheetStatusProvider';
import { formatDate } from '@utils';
import { TestsheetLabelProvider } from './TestSheetLabelProvider';

export const TestsheetCard: React.FC<{ testsheet: TestsheetListingItem }> = ({ testsheet }) => {
    return (
        <div className="testsheet-card">
            <div className="testsheet-card-container">
                <div className="testsheet-card-header-left">
                    <TestsheetStatusProvider status={testsheet.status} />
                </div>
                <div className="testsheet-card-header-right">
                    <div className="testsheet-card-header-right-title">
                        {testsheet.title.includes('// ') ? (
                            <>
                                <span className="testsheet-tag">
                                    {testsheet.title.split('// ')[0].trim()}
                                </span>
                                <Typography intrinsic="h4" color="marine" defaultSpacing>
                                    {testsheet.title.split('// ').slice(1).join('// ').trim()}
                                </Typography>
                            </>
                        ) : (
                            <Typography intrinsic="h4" color="marine" defaultSpacing>
                                {testsheet.title}
                            </Typography>
                        )}
                        <Typography intrinsic="p" color="grey" defaultSpacing>
                            ({formatDate(testsheet.date_create)})
                        </Typography>
                    </div>

                    <Typography intrinsic="p" color="grey" defaultSpacing>
                        <TestsheetLabelProvider testsheet={testsheet} />
                    </Typography>
                </div>
            </div>
        </div>
    );
};
